var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{attrs:{"fluid":"","pa-5":"","id":"logtable"}},[_c('h1',[_vm._v("Welcome to order2flow")])])
}
var staticRenderFns = []

export { render, staticRenderFns }